import {MessageModalForm} from './MessageModalForm'

const MessageModalFormWrapper = ({setShowMessageModal, messageType, getUser, user}) => {
    return <MessageModalForm setShowMessageModal={setShowMessageModal} messageType={messageType} getUser={getUser} user={user} />
}

export {MessageModalFormWrapper}
